// extracted by mini-css-extract-plugin
module.exports = {"page":"Cooperation_page__EGg8C"};